import { Box, Container, Stack, Typography } from "@mui/material";
import { images } from "../../assets";
import { useNavigate, useLocation } from "react-router-dom";
import en from "../../locales/en.json";
import es from "../../locales/es.json";
import it from "../../locales/it.json";
import fr from "../../locales/fr.json";
import de from "../../locales/de.json";
import pt from "../../locales/pt.json";
import ru from "../../locales/ru.json";
import zh from "../../locales/zh.json";
import ja from "../../locales/ja.json";
import ko from "../../locales/ko.json";
import ar from "../../locales/ar.json";
import hi from "../../locales/hi.json";
import nl from "../../locales/nl.json";

const locales = { en, es, it, fr, de, pt, ru, zh, ja, ko, ar, hi, nl };

const TermsAndConditions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const language = location?.state?.language || "en";
  
  // Ensure we have a valid locale object, with defensive checks
  const selectedLocale = locales[language];
  const fallbackLocale = locales.en || {};
  const t = selectedLocale || fallbackLocale;
  
  // Fallback content if translations are missing
  const hasTranslationError = !t?.termsAndConditions;

  return (
    <Box sx={{ backgroundColor: "#f5f5f7", minHeight: "100vh" }}>
      <Stack
        height="100px"
        p={2}
        display="flex"
        justifyContent="space-between"
        sx={{ width: { xs: "80%", sm: "60%" } }}
        direction="row"
        alignItems={"center"}
      >
        <Box>
          <img
            src={images.weuiBackFilled}
            alt="Go Back"
            style={{ cursor: "pointer" }}
            onClick={() => navigate(-1, { state: { language } })}
          />
        </Box>
        <Box sx={{ width: { xs: "60%", sm: "200px" } }}>
          <img
            src={images.certageLogo}
            alt="Logo"
            style={{ width: "100%", height: "auto" }}
          />
        </Box>
      </Stack>

      <Container maxWidth="lg">
        {hasTranslationError && (
          <Typography textAlign="center" fontSize={12} color="error" sx={{ mb: 2 }}>
            [Translation Error - Language: {language}]
          </Typography>
        )}
        <Typography fontSize={30} fontWeight={700} fontFamily={"inter"} mb={2}>
          {t?.termsAndConditions?.heading || "Terms and Conditions"}
        </Typography>

        <Typography>{t?.termsAndConditions?.content || ""}</Typography>

        <Typography variant="h6" mt={3}>
          {t?.termsAndConditions?.section1Title || ""}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 14, sm: 18 },
            fontWeight: 500,
            color: "#403E3E",
            lineHeight: "137.5%",
            fontFamily: "Inter",
          }}
        >
          {t?.termsAndConditions?.section1Content || ""}
        </Typography>

        <Typography variant="h6" mt={3}>
          {t?.termsAndConditions?.section2Title || ""}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 14, sm: 18 },
            fontWeight: 500,
            color: "#403E3E",
            lineHeight: "137.5%",
            fontFamily: "Inter",
          }}
        >
          {t?.termsAndConditions?.section2Content || ""}
        </Typography>

        <Typography variant="h6" mt={3}>
          {t?.termsAndConditions?.section3Title || ""}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 14, sm: 18 },
            fontWeight: 500,
            color: "#403E3E",
            lineHeight: "137.5%",
            fontFamily: "Inter",
          }}
        >
          {t?.termsAndConditions?.section3Content || ""}
        </Typography>

        <Typography variant="h6" mt={3}>
          {t?.termsAndConditions?.section4Title || ""}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 14, sm: 18 },
            fontWeight: 500,
            color: "#403E3E",
            lineHeight: "137.5%",
            fontFamily: "Inter",
          }}
        >
          {t?.termsAndConditions?.section4Content || ""}
        </Typography>

        <Typography variant="h6" mt={3}>
          {t?.termsAndConditions?.section5Title || ""}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 14, sm: 18 },
            fontWeight: 500,
            color: "#403E3E",
            lineHeight: "137.5%",
            fontFamily: "Inter",
          }}
        >
          {t?.termsAndConditions?.section5Content || ""}
        </Typography>

        <Typography variant="h6" mt={3}>
          {t?.termsAndConditions?.section6Title || ""}
        </Typography>
        <Typography>{t?.termsAndConditions?.section6Content || ""}</Typography>

        <Typography variant="h6" mt={3}>
          {t?.termsAndConditions?.section7Title || ""}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 14, sm: 18 },
            fontWeight: 500,
            color: "#403E3E",
            lineHeight: "137.5%",
            fontFamily: "Inter",
          }}
        >
          {t?.termsAndConditions?.section7Content || ""}
        </Typography>
      </Container>
    </Box>
  );
};

export default TermsAndConditions;
